module.exports = __webpack_public_path__ + "img/newfb.492acd34.svg";